export default {
  ReceiptSummaryList: {
    Title: 'Bảng tổng hợp biên lai thu tiền',
  },
  ReceiptSummaryDetail: {
    Title: 'Tổng hợp biên lai thu tiền',
    SummaryNumber: 'Số bảng TH',
    SummaryNumberTitle: 'Số bảng tổng hợp',
    SummaryDate: 'Ngày bảng TH',
    SummaryDateTitle: 'Ngày bảng tổng hợp',
    Description: 'Diễn giải',
    Close: 'Đóng',
    CloseTooltip: 'Đóng (ESC)',
    Refresh: 'Nạp',
    RefreshTooltip: 'Nạp (Ctrl + R)',
    SelectReceipt: 'Chọn biên lai thu tiền',
  },
  ReceiptSummarySelect: {
    Title: 'Chọn biên lai thu tiền',
    FromDate: 'Ngày bắt đầu',
    EndDate: 'Ngày kết thúc',
    Find: 'Tìm',
  },
};
